module.exports = __webpack_public_path__ + "img/login-thumbnail.808aad0b.png";